/**
 * Layout configuration for Blue Shield of California
 */
const layoutConfig = {
  spanFullWidth: true,
  spacing: {
    unit: 10, // Custom spacing unit for Blueshield
  },
};

export default layoutConfig;
